// extracted by mini-css-extract-plugin
export var markdownBlock = "Markdown--markdownBlock--KkWZX";
export var markdownBox = "Markdown--markdownBox--BLsse";
export var markdownList = "Markdown--markdownList--Nxju4";
export var markdownList___ordered = "Markdown--markdownList___ordered--gC3Yl";
export var markdownList__item = "Markdown--markdownList__item--BTGMr";
export var markdownTelephone = "Markdown--markdownTelephone--BoH3I";
export var markdown__button = "Markdown--markdown__button--YzEeb";
export var tkMyriadProSemiCondensed = "Markdown--tk-myriad-pro-semi-condensed--Y5w4u";